module.exports = __webpack_public_path__ + "static/media/nutritionist-cover.c93a81e4.png";